import { render } from "./MobileAlert.vue?vue&type=template&id=b7d882e8&scoped=true"
import script from "./MobileAlert.vue?vue&type=script&lang=js"
export * from "./MobileAlert.vue?vue&type=script&lang=js"

import "./MobileAlert.vue?vue&type=style&index=0&id=b7d882e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7d882e8"]])

export default __exports__